// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3V2dY","rootMobile":"styles_rootMobile__2dzKU"};